import {React, useEffect, useState} from 'react'
import { Box } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker'
import { useInput } from 'react-admin'
import TextField from '@mui/material/TextField'
import 'dayjs/locale/es';

export const TimePickerViews = ({ label, source, validate, disabled, onChange, minTime, isNull }) => {
  const { field, fieldState } = useInput({ source, validate: validate })
  const { error } = fieldState
  const [value, setValue] = useState(field.value ? new Date(field.value):'')

  useEffect(()=>{
    if(isNull){
      onChangeField(null)
    }
  },[isNull])

  const onChangeField = (value) => {
    setValue(value)
    const selectedTime = value ? new Date(value) : null
    const finalTime = selectedTime ? new Date(selectedTime.getTime() - selectedTime.getTimezoneOffset() * 60000) : null
    field.onChange(finalTime)
    onChange && onChange( finalTime)
  }

  const renderInput = (params) => <TextField {...params} value={value} onChange={setValue} error={error} helperText={error} />
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
      <Box sx={{ minWidth: 210 }}>
        <MobileTimePicker
          className='datePicker'
          label={label}
          disabled={disabled}
          value={(value || null)}
          minTime={minTime}
          views={['hours', 'minutes']}
          onChange={onChangeField}
          error={error}
          helperText={error}
          ampm={false}
          renderInput={renderInput}
        />
      </Box>
    </LocalizationProvider>
  )
}
